// Module
var code = "<div class=\"summary-chart col-xs-12 col-sm-12 col-md-12 col-lg-12\"> <div class=row> <h3 class=\"chart-title col-xs-12 col-sm-12 col-md-12 col-lg-12\">{{getSummaryChartTitle()}}</h3> </div> </div> ";
// Exports
module.exports = code;